module.exports = __webpack_public_path__ + "img/post-image1.9e5c281d.png";